import { useUserManagementServiceV1 } from "@rw1/api-services";
import { UserManagement_V1 } from "@rw1/auto-generated-clients";
import { useFetchAll } from "../../../hooks/useFetchAll";

interface UseUserGroupsOptions {
  userId: string;
  pageSize?: number;
  enabled?: boolean;
}

interface UseUserGroupsResult {
  userGroups: UserManagement_V1.UserGroup[];
  loading: boolean;
  error: Error | null;
  isFetching: boolean;
}

const USER_GROUPS_QUERY_KEY = "userGroups";

export const useUserGroups = (
  options: UseUserGroupsOptions,
): UseUserGroupsResult => {
  const { userId, pageSize = 100, enabled = true } = options;

  const userManagementService = useUserManagementServiceV1();

  const { data, isLoading, error, isFetching } =
    useFetchAll<UserManagement_V1.UserGroup>(
      [USER_GROUPS_QUERY_KEY, userId],
      (page, size) =>
        userManagementService.getUserGroupsOfSpecificUser(
          userId,
          page,
          size,
          undefined,
        ),
      {
        enabled: enabled && !!userId,
        pageSize,
      },
    );

  return {
    userGroups: data ?? [],
    loading: isLoading,
    error,
    isFetching,
  };
};
